import { FC, MouseEventHandler } from 'react';
import {
  IconButton,
  Typography,
  Stack,
} from 'material-hu';

export type LoginButtonProps = {
  logo: string;
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement> | (() => void);
};

const LoginButton: FC<LoginButtonProps> = (props) => {
  const {
    logo,
    label,
    onClick,
  } = props;

  return (
    <Stack sx={{ alignItems: 'center' }}>
      <IconButton
        onClick={onClick}
        sx={{
          p: 2,
          borderStyle: 'solid',
          borderColor: 'background.default',
          borderWidth: '2px',
          width: '50px',
          height: '50px',
        }}
      >
        <img
          src={logo}
          alt={label}
          height={20}
          width={20}
        />
      </IconButton>
      <Typography
        color="secondary"
        variant="body2"
      >
        {label}
      </Typography>
    </Stack>
  );
};

export default LoginButton;
